<template>
  <div class="certification-details">
    <div class="certification-details__item">
      <span>DIFFICULTY</span>
      <div class="certification-details__item--difficulty">
        <Difficulty :difficulty="difficulty" :colored="true" />
      </div>
    </div>
    <div class="certification-details__item">
      <span>TIME LIMIT</span>
      <span>{{ timeLimit }}</span>
    </div>
    <div class="certification-details__item">
      <span>QUESTIONS</span>
      <span>{{ questions }}</span>
    </div>
    <div class="certification-details__item" v-if="objectives">
      <span>LAB OBJECTIVES</span>
      <span>{{ objectives }}</span>
    </div>
  </div>
</template>
<script>
import Difficulty from '@/components/properties/Difficulty.vue'

export default {
  name: 'CertificationDetails',
  props: {
    difficulty: {
      type: String,
      required: true,
    },
    timeLimit: {
      type: String,
      required: true,
    },
    questions: {
      type: Number,
      required: true,
    },
    objectives: {
      type: Number,
      required: false,
    },
  },
  components: {
    Difficulty,
  },
}
</script>
<style lang="scss" scoped>
.certification-details {
  background: var(--glass-dark);
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;

  font-family: var(--font-book);
  font-size: 12px;
  line-height: 14px;

  &__item {
    border-block-end: 1px solid var(--tundora-gray);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    color: var(--mid-gray);

    &:first-child {
      padding-top: 0;
      padding-bottom: 6px;
    }
    &:last-child {
      padding-bottom: 0;
      border-block-end: none;
    }
  }

  @include mobile {
    justify-content: space-between;
  }
}
</style>
